
import { createTheme } from '@mui/material';
import { ThemeProvider } from 'styled-components';
import ManageTeamCustomerTable from '../../components/ManageTeamCustomerTable';
const defaultTheme = createTheme();
const ManageCustomerTeam = () => {
  return (
    <ThemeProvider theme={defaultTheme}>
       <ManageTeamCustomerTable/>
    </ThemeProvider>
  )
}

export default ManageCustomerTeam